"use strict";
/**
 * Type Expression Operators: https://docs.mongodb.com/manual/reference/operator/aggregation/#type-expression-operators
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.$type = void 0;
var core_1 = require("../../../core");
var types_1 = require("../../../types");
var util_1 = require("../../../util");
function $type(obj, expr, options) {
    var val = (0, core_1.computeValue)(obj, expr, null, options);
    var typename = (0, util_1.getType)(val);
    var nativeType = typename.toLowerCase();
    switch (nativeType) {
        case types_1.JsType.BOOLEAN:
            return types_1.BsonType.BOOL;
        case types_1.JsType.NUMBER:
            if (val.toString().indexOf(".") >= 0)
                return types_1.BsonType.DOUBLE;
            return val >= util_1.MIN_INT && val <= util_1.MAX_INT ? types_1.BsonType.INT : types_1.BsonType.LONG;
        case types_1.JsType.REGEXP:
            return types_1.BsonType.REGEX;
        default:
            return nativeType;
    }
}
exports.$type = $type;
